import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bookings: [],
  upcomingBooking: [],
  upcomingBookingLength: 0,
  jobsForToday: [],
  jobsForTodayLength: 0,
  jobsForTomorrow: [],
  jobsForTomorrowLength: 0,
  bookingDetails: {},
  bookingsLoading: true,
  sections: {
    allBooking: true,
    upcomingBooking: false,
    jobsForToday: false,
    jobsForTomorrow: false,
  },
  filteredBookings: [],
  filteredBookingsNumber: 0,
  isSearch: false,
  notFound: false,
  pageCount: 1,
  totalBookingCount: 0,
  filterForm: {
    singleDate: null,
    startDate: null,
    endDate: null,
    passengerName: "",
    driverName: "",
    bookingId: "",
    dateType: "travel-date",
  },
  filterFormDateRangeError: false,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setFilterFormDateRangeError: (state, action) => {
      state.filterFormDateRangeError = action.payload;
    },
    setNotFound: (state, action) => {
      state.notFound = action.payload.notFound;
    },
    setFilterForm: (state, action) => {
      state.filterForm = {
        ...state?.filterForm,
        ...action.payload,
      };

      if (state.filterForm?.startDate && state.filterForm?.endDate) {
        state.filterFormDateRangeError = false;
      }
    },
    setIsSearch: (state, action) => {
      state.isSearch = action.payload.isSearch;
    },
    clearFilterBooking: (state, action) => {
      state.filteredBookings = [];
      state.filteredBookingsNumber = 0;
      state.filterForm = {
        singleDate: null,
        startDate: null,
        endDate: null,
        passengerName: "",
        driverName: "",
        bookingId: "",
        dateType: "travel-date",
      };
      state.isSearch = false;
      state.notFound = false;
    },
    setFilteredBookings: (state, action) => {
      state.filteredBookings = action.payload.filteredBookings;
      if (
        state.filterForm.singleDate === null &&
        state.filterForm.startDate === state.filterForm.endDate
      ) {
        state.filterForm.singleDate = state.filterForm.startDate;
        state.filterForm.startDate = null;
        state.filterForm.endDate = null;
      }
    },
    setFilteredBookingsNumber: (state, action) => {
      state.filteredBookingsNumber = action.payload.filteredBookingsLength;
    },
    setUpcomingBooking: (state, action) => {
      state.upcomingBooking = action.payload.upcomingBooking;
    },
    setUpcomingBookingLength: (state, action) => {
      state.upcomingBookingLength = action.payload.upcomingBookingLength;
    },
    setJobsForToday: (state, action) => {
      state.jobsForToday = action.payload.jobsForToday;
    },
    setJobsForTodayLength: (state, action) => {
      state.jobsForTodayLength = action.payload.jobsForTodayLength;
    },
    setJobsForTomorrow: (state, action) => {
      state.jobsForTomorrow = action.payload.jobsForTomorrow;
    },
    setJobsForTomorrowLength: (state, action) => {
      state.jobsForTomorrowLength = action.payload.jobsForTomorrowLength;
    },
    setSections: (state, action) => {
      state.sections = action.payload;
    },
    setBookingsLoading: (state, action) => {
      state.bookingsLoading = action.payload.bookingsLoading;
    },
    getBookings: (state, action) => {
      state.bookings = action.payload.bookings;
    },
    getBookingDetails: (state, action) => {
      state.bookingDetails = action.payload.bookingDetails;
    },
    setPageNext(state, action) {
      state.pageCount = state.pageCount + 1;
    },
    setPagePrev(state, action) {
      state.pageCount = state.pageCount - 1;
    },
    setTotalBookingCount: (state, action) => {
      state.totalBookingCount = action.payload.totalBookingCount;
    },
  },
});

export const {
  setUpcomingBooking,
  setUpcomingBookingLength,
  setJobsForToday,
  setJobsForTodayLength,
  setJobsForTomorrow,
  setJobsForTomorrowLength,
  setBookingsLoading,
  getBookings,
  getBookingDetails,
  setSections,
  setPageNext,
  setPagePrev,
  setTotalBookingCount,
  setFilteredBookings,
  setFilteredBookingsNumber,
  clearFilterBooking,
  setIsSearch,
  setFilterForm,
  setNotFound,
  setFilterFormDateRangeError,
} = bookingSlice.actions;
export const bookingReducer = bookingSlice.reducer;
